import { render, staticRenderFns } from "./BaseEvent.vue?vue&type=template&id=85e952ba&scoped=true&"
import script from "./BaseEvent.vue?vue&type=script&lang=js&"
export * from "./BaseEvent.vue?vue&type=script&lang=js&"
import style0 from "./BaseEvent.vue?vue&type=style&index=0&id=85e952ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e952ba",
  null
  
)

export default component.exports